import { Helmet } from 'react-helmet-async';
import { ServiceNav } from "@/components/ServiceNav";
import { ServiceLayout } from "@/components/ServiceLayout";
import NutritionCounselling from "./services/NutritionCounselling";
import GutHealth from "./services/GutHealth";
import WeightManagement from "./services/WeightManagement";
import SportsNutrition from "./services/SportsNutrition";
import ChronicDiseases from "./services/ChronicDiseases";
import LifecycleNutrition from "./services/LifecycleNutrition";
const Services = () => {
  return <>
      <Helmet>
        <title>Nutrition & Dietician Services | Functional Foodie</title>
        <meta name="description" content="Explore our dietician services, from weight loss to gut health. Functional Foodie offers expert nutrition advice in Johannesburg. Discover the right plan for you - get started now!" />
      </Helmet>
      <div className="min-h-screen pt-40 pb-16">
        <div className="container mx-auto px-4 mb-12">
          <h1 className="text-4xl font-bold text-center text-primary mb-8 my-px">Our Services</h1>
          <p className="text-lg text-center text-gray-600 max-w-3xl mx-auto">
            At Functional Foodie, we offer a comprehensive range of nutrition services to support your health and wellness goals. Browse through our services below or click on a specific service to learn more.
          </p>
        </div>

        <ServiceNav />
        
        <div className="space-y-16 mt-8">
          <ServiceLayout serviceId="nutrition-counselling">
            <NutritionCounselling />
          </ServiceLayout>
          
          <ServiceLayout serviceId="gut-health">
            <GutHealth />
          </ServiceLayout>
          
          <ServiceLayout serviceId="weight-management">
            <WeightManagement />
          </ServiceLayout>
          
          <ServiceLayout serviceId="sports-nutrition">
            <SportsNutrition />
          </ServiceLayout>
          
          <ServiceLayout serviceId="chronic-diseases">
            <ChronicDiseases />
          </ServiceLayout>
          
          <ServiceLayout serviceId="lifecycle-nutrition">
            <LifecycleNutrition />
          </ServiceLayout>
        </div>
      </div>
    </>;
};
export default Services;